var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 18C14.45 18 13.9793 17.8043 13.588 17.413C13.196 17.021 13 16.55 13 16V15H11C10.45 15 9.97933 14.8043 9.588 14.413C9.196 14.021 9 13.55 9 13V5H7V6C7 6.55 6.804 7.02067 6.412 7.412C6.02067 7.804 5.55 8 5 8H2C1.45 8 0.979333 7.804 0.588 7.412C0.196 7.02067 0 6.55 0 6V2C0 1.45 0.196 0.979 0.588 0.587C0.979333 0.195667 1.45 0 2 0H5C5.55 0 6.02067 0.195667 6.412 0.587C6.804 0.979 7 1.45 7 2V3H13V2C13 1.45 13.196 0.979 13.588 0.587C13.9793 0.195667 14.45 0 15 0H18C18.55 0 19.021 0.195667 19.413 0.587C19.8043 0.979 20 1.45 20 2V6C20 6.55 19.8043 7.02067 19.413 7.412C19.021 7.804 18.55 8 18 8H15C14.45 8 13.9793 7.804 13.588 7.412C13.196 7.02067 13 6.55 13 6V5H11V13H13V12C13 11.45 13.196 10.979 13.588 10.587C13.9793 10.1957 14.45 10 15 10H18C18.55 10 19.021 10.1957 19.413 10.587C19.8043 10.979 20 11.45 20 12V16C20 16.55 19.8043 17.021 19.413 17.413C19.021 17.8043 18.55 18 18 18H15ZM15 6H18V2H15V6ZM15 16H18V12H15V16ZM2 6H5V2H2V6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganization);
export default __webpack_public_path__ + "static/media/Organization.d4bad1d6d659e7f99359b4a235530c7e.svg";
export { ForwardRef as ReactComponent };